import React from "react";
import { Box, Button, Typography, Container } from "@mui/material";
import { motion } from "framer-motion";

const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

const SlidingQuestion = ({ questionObject, buttonClick }) => {
  const question = questionObject.question;
  const answers = questionObject.responseChoices;

  return (
    <motion.div
      key={question}
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.4, ease: [0.25, 0.1, 0.25, 1] }}
    >
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          py: { xs: 2, sm: 4 },
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            color: "text.primary",
            lineHeight: 1.5,
            mb: { xs: 4, sm: 5 },
            fontSize: { xs: "1.15rem", sm: "1.35rem", md: "1.5rem" },
            maxWidth: 600,
            letterSpacing: "-0.01em",
          }}
        >
          {question}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            width: "100%",
            maxWidth: 420,
          }}
          className="stagger-children"
        >
          {answers.length === 0 && (
            <Button
              variant="contained"
              size="large"
              onClick={() => buttonClick(0)}
              sx={{
                py: 1.5,
                px: 5,
                fontSize: "1rem",
                borderRadius: 3,
                background:
                  "linear-gradient(135deg, #7B1FA2 0%, #9C27B0 50%, #E040FB 100%)",
                color: "#FFFFFF",
                fontWeight: 600,
                textTransform: "none",
                boxShadow: "0 4px 16px rgba(123, 31, 162, 0.25)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #6A1B9A 0%, #8E24AA 50%, #D500F9 100%)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 24px rgba(123, 31, 162, 0.35)",
                },
                "&:active": {
                  transform: "translateY(0)",
                },
                transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              Continue
            </Button>
          )}

          {answers.length > 0 &&
            answers.map((answer, index) => (
              <Button
                key={index}
                variant="outlined"
                size="large"
                onClick={() => buttonClick(index)}
                sx={{
                  py: 1.5,
                  px: 3,
                  fontSize: "1rem",
                  borderRadius: 3,
                  borderWidth: 2,
                  borderColor: "rgba(123, 31, 162, 0.2)",
                  color: "text.primary",
                  fontWeight: 500,
                  textTransform: "none",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                  backdropFilter: "blur(8px)",
                  "&:hover": {
                    borderWidth: 2,
                    borderColor: "primary.main",
                    backgroundColor: "rgba(123, 31, 162, 0.04)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 4px 16px rgba(123, 31, 162, 0.12)",
                  },
                  "&:active": {
                    transform: "translateY(0)",
                    backgroundColor: "rgba(123, 31, 162, 0.08)",
                  },
                  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              >
                {answer}
              </Button>
            ))}
        </Box>
      </Container>
    </motion.div>
  );
};

export default SlidingQuestion;
